import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

// interface 



const JobListingByDepartment = ({ jobsByDepartment, departments, locations, primaryColor }: any) => {
  const { base_slug, jobId } = useParams(); // Get both parameters
  const [lighterShade, setLighterShade] = useState<string | null>(null);
  // Helper function to find department name by ID
  const getDepartmentName = (departmentId: any) => {
    const department = departments.find((dept: any) => dept.id === departmentId);
    return department ? department.department_name : '';
  };

  const getLocationName = (locationStr: string, locations: { id: string; location_name: string }[]) => {
    if (!locationStr) return null;

    const locationIds = locationStr.split(',');

    const locationElements = locationIds.map((id, index) => {
      const location = locations.find((loc) => loc.id === id);
      return location ? (
        <span key={id} className="flex items-center gap-x-[6px]">
          {index > 0 && (
            <div className="h-1 w-1 bg-[#030b3e5c] rounded-xl mx-0"></div>
          )}
          {location.location_name}
        </span>
      ) : null;
    });

    return locationElements.length > 0 ? locationElements : null;
  };

  useEffect(() => {
    if (primaryColor) {
      document.documentElement.style.setProperty('--component-primary-color', primaryColor);
      const lighter = calculateLighterShade(primaryColor, 0.26);
      const mainBgShare = calculateLighterShade(primaryColor, 0.93);
      setLighterShade(lighter);
      document.documentElement.style.setProperty('--hover-primary-color', lighter);
      document.documentElement.style.setProperty('--main-bg-color', mainBgShare);
    }
  }, [primaryColor]);

  // Helper function to calculate lighter shade for hover state
  const calculateLighterShade = (hex: any, percent: any) => {
    // Remove the hash if it exists
    hex = hex.replace('#', '');

    // Convert hex to RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Calculate lighter values (adding the percentage)
    r = Math.min(255, Math.round(r + (255 - r) * percent));
    g = Math.min(255, Math.round(g + (255 - g) * percent));
    b = Math.min(255, Math.round(b + (255 - b) * percent));

    // Convert back to hex
    const toHex = (n: any) => {
      const hex = n.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };


  return (
    <div className="space-y-8">
      {jobsByDepartment?.map((departmentGroup: any) => {
        const departmentName = getDepartmentName(departmentGroup.job_department_id);

        return (
          <div key={departmentGroup.job_department_id} className="!mb-4 ">
            <h1 className="mx-4 md:mx-[55px] lg:mx-[55px] uppercase text-[14px] lg:text-[16px] font-[600] leading-4 tracking-[-0.01rem] mb-4"
              style={{ color: 'var(--component-primary-color)' }}
            >
              {departmentName}
            </h1>
            <div className="horizontal-line mx-0 lg:!mx-[55px] w-full lg:!w-[84.5%]"></div>
            <div className="space-y-2 md:space-y-4 lg:space-y-4 px-0 lg:px-[40px]">
              {departmentGroup.jobs.map((job: any) => (
                <Link
                  to={`/${base_slug}/${job.id}`}
                  key={job.id}
                  className="flex justify-between gap-x-2 items-center w-full bg-transparent rounded-[0.5rem] hover:bg-[#17295d0a] py-4 px-[16px] md:px-[12px] lg:px-[12px]"
                >
                  <div className="w-auto lg:w-[80%] flex flex-col gap-y-1 lg:gap-y-2">
                    <h2 className="text-[14px] capitalize lg:text-[1.125rem] line-clamp-2 font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem]">
                      {job.title}
                    </h2>
                    <p className="flex items-center gap-[6px] flex-wrap text-[0.875rem] md:text-[0.875rem] line-clamp-2 lg:text-[0.875rem] leading-4 capitalize font-medium text-[#030b3e5c]">
                      {
                        job.workplace_type === 'On_site' ? 'On-site'
                          : job.workplace_type === 'Hybrid' ? 'Hybrid'
                            : job.workplace_type === 'Remote' ? 'Remote'
                              : job.workplace_type

                      }
                      {
                        job.job_type &&
                        <span className='flex items-center gap-x-[6px]'>
                          <div className='h-1 w-1 bg-[#030b3e5c] rounded-xl'></div>
                          {
                            job.job_type === 'Full_Time' ? 'Full time'
                              : job.job_type === 'Part_Time' ? 'Part time'
                                : job.job_type === 'Contract' ? 'Contract'
                                  : job.job_type === 'Internship' ? 'Internship'
                                    : job.job_type === 'Temporary' ? 'Temporary'
                                      : job.job_type === 'Volunteer' ? 'Volunteer'
                                        : job.job_type === 'Other' ? 'Other'
                                          : job.job_type
                          }
                        </span>
                      }
                      {
                        job?.experience_level &&
                        <span className='flex items-center gap-x-[6px]'>
                          <div className='h-1 w-1 bg-[#030b3e5c] rounded-xl'></div>
                          {
                            job?.experience_level === 'Intern' ? 'Intern'
                            : job?.experience_level === 'Entry Level (0 - 2  years)' ? 'Entry Level (0 - 2  years)'
                            : job?.experience_level === 'Mid (3 - 7 years)' ? 'Mid (3 - 7 years)'
                            : job?.experience_level === 'Senior (8 - 12 years)' ? 'Senior (8 - 12 years)'
                            : job?.experience_level === 'Executive (15+ years)' ? 'Executive (15+ years)'
                            : job?.experience_level === 'Executive (15+ years)' ? 'Executive (15+ years)'
                            : job?.experience_level
                          }
                        </span>
                      }
                      {
                        job.job_type && job.location !== null &&
                        <div className='h-1 w-1 bg-[#030b3e5c] rounded-xl'>

                        </div>
                      }
                      {getLocationName(job.location, locations)}

                    </p>
                  </div>
                  <div className="w-auto lg:w-[20%] flex justify-end">
                    <button
                      type="button"
                      style={{
                        background: 'var(--component-primary-color)',
                      }}
                      className="button-hover inline-flex shrink-0 justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm"
                    >
                      Apply
                    </button>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default JobListingByDepartment;